module.exports = "https://product-cdn.staging.surfline.com/kbyg/_next/static/images/all-stories-tile-desktop-47b0946453ae4790acf876a8e9067ca3.png";